import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {MenuItem} from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class BreadCrumbService {
  items: Observable<MenuItem[]>;
  itemsSubject: BehaviorSubject<MenuItem[]>;

  constructor() {
    this.itemsSubject = new BehaviorSubject<MenuItem[]>([]);
    this.items = this.itemsSubject.asObservable();
  }
}
